import { DiagnosticMethod } from "apps/project-iq/models/IDiagnostic";

export type LinkCategory =
  | "people"
  | "value"
  | "engagement_plan_deliverables"
  | "nh_diagnostic_iq_quick_links"
  | "nh_diagnostic_iq_diagnostic_run_links"
  | "value_story"
  | "ai_analytics_quick_links";

export const LINK_CATEGORY_LABELS: Record<LinkCategory, string> = {
  people: "People",
  value: "Value",
  engagement_plan_deliverables: "Engagement Plan - Deliverables",
  nh_diagnostic_iq_quick_links: "NH Diagnostic IQ - Quick Links",
  nh_diagnostic_iq_diagnostic_run_links:
    "NH Diagnostic IQ - Diagnostic Run Links",
  value_story: "Value Story",
  ai_analytics_quick_links: "AI Analytics - Quick Links",
};

export const DIAGNOSTIC_RUN_CATEGORY: LinkCategory =
  "nh_diagnostic_iq_diagnostic_run_links";
export const QUICK_LINKS_CATEGORY: LinkCategory =
  "nh_diagnostic_iq_quick_links";
export const AI_ANALYTICS_QUICK_LINKS_CATEGORY: LinkCategory =
  "ai_analytics_quick_links";

export const SUBTEXT_CATEGORIES: ReadonlySet<LinkCategory> = new Set([
  QUICK_LINKS_CATEGORY,
  AI_ANALYTICS_QUICK_LINKS_CATEGORY,
]);

export interface IAdminLink {
  id: string;
  category: LinkCategory;
  linkType: DiagnosticMethod | null;
  displayName: string;
  url: string;
  subtext: string | null;
}
